import { render } from "./ReportTaxInvoiceRegister.vue?vue&type=template&id=010b250b&scoped=true"
import script from "./ReportTaxInvoiceRegister.vue?vue&type=script&lang=js"
export * from "./ReportTaxInvoiceRegister.vue?vue&type=script&lang=js"

import "./ReportTaxInvoiceRegister.vue?vue&type=style&index=0&id=010b250b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010b250b"]])

export default __exports__